// extracted by mini-css-extract-plugin
module.exports = {"signup":"theia_auth_signup__3_faM","controls":"theia_auth_controls__1SORS"};